import ShapesButtonSVG from "../../Media/ShapesButton";
import styled from "styled-components";
import useStore from "../../Store/Store";
import { useEffect, useState } from "react";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";

const StyledButton = styled(IconButton)({
  margin: "8px", // Standardizing margin
  backgroundColor: "#ff9999",
  "&:hover": {
    backgroundColor: "#ff8080",
  },
});

const ShapesButtonWrapper = styled.div`
  position: fixed;
  top: 60vh; /* Moved up, maintaining 10vh spacing */
  left: -0.7vw;
  height: 5vw;
  width: 5vw;
  cursor: pointer;

  /* Hover states */
  &:hover .shapesIcon {
    fill: #ffaea6;
    color: #ffaea6;
  }
  &:hover .halfCircle {
    fill: white;
  }
  &:hover .pencil {
    fill: #ffb6a6;
  }
`;

const ShapesButton: React.FC<any> = () => {
  const { postToDrawio } = useStore((state) => ({
    postToDrawio: state.postToDrawio,
  }));

  const [showPanel, setShowPanel] = useState(false);

  const handleClick = async () => {
    setShowPanel(!showPanel);
  };

  useEffect(() => {
    postToDrawio({
      action: "TOGGLE_SHAPES_PANEL",
      data: { show: showPanel },
    });
  }, [postToDrawio, showPanel]);

  return (
    <Tooltip title="Add shapes">
      <ShapesButtonWrapper
        className="ShapesButtonWrapper"
        onClick={handleClick}
      >
        <ShapesButtonSVG />
        <AddRoundedIcon
          htmlColor="#ffffff"
          style={{
            position: "absolute",
            top: "30%",
            left: "18%",
            width: "30px",
            height: "30px",
          }}
          className="shapesIcon"
        />
      </ShapesButtonWrapper>
    </Tooltip>
  );
};

export default ShapesButton;
